var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',{attrs:{"fluid":""}},[_c('div',{staticClass:"metro-menu"},[_c('div',{staticClass:"tile tile-4 small",on:{"click":(e) => {
        e.preventDefault()
        e.stopPropagation();
        _vm.$router.push({ path: '/administracion/movimientos/clientes/cotizaciones' });
      }}},[_c('i',{staticClass:"bi bi-file-earmark-text"}),_c('span',[_vm._v("Cotizaciones")])]),_c('div',{staticClass:"tile tile-2 small",on:{"click":(e) => {
        e.preventDefault()
        e.stopPropagation();
        _vm.$router.push({ path: '/administracion/movimientos/clientes/pedidos' });
      }}},[_c('i',{staticClass:"bi bi-clipboard-check"}),_c('span',[_vm._v("Pedidos")])]),_c('div',{staticClass:"tile tile-3 small",on:{"click":(e) => {
        e.preventDefault()
        e.stopPropagation();
        _vm.$router.push({ path: '/administracion/movimientos/clientes/entregasmercancia' });
      }}},[_c('i',{staticClass:"bi bi-truck"}),_c('span',[_vm._v("Entregas de Mercancía")])]),_c('div',{staticClass:"tile tile-5 small",on:{"click":(e) => {
        e.preventDefault()
        e.stopPropagation();
        _vm.$router.push({ path: '/administracion/movimientos/clientes/facturasventa' });
      }}},[_c('i',{staticClass:"bi bi-receipt-cutoff"}),_c('span',[_vm._v("Facturas de Venta")])]),_c('div',{staticClass:"tile tile-6 small",on:{"click":(e) => {
        e.preventDefault()
        e.stopPropagation();
        _vm.$router.push({ path: '/administracion/movimientos/clientes/garantias' });
      }}},[_c('i',{staticClass:"bi bi-award"}),_c('span',[_vm._v("Garantías")])]),_c('div',{staticClass:"tile tile-7 small",on:{"click":(e) => {
        e.preventDefault()
        e.stopPropagation();
        _vm.$router.push({ path: '/administracion/movimientos/clientes/controlseguimientodocumentos' });
      }}},[_c('i',{staticClass:"bi bi-geo-alt"}),_c('span',[_vm._v("Seguimiento de Entregas")])]),_c('div',{staticClass:"tile tile-12 small",on:{"click":(e) => {
        e.preventDefault()
        e.stopPropagation();
        _vm.$router.push({ path: '/administracion/movimientos/clientes/contratosarrendamientos' });
      }}},[_c('i',{staticClass:"bi bi-file-earmark-medical"}),_c('span',[_vm._v("Contratos de Arrendamiento")])]),_c('div',{staticClass:"tile tile-10 medium",on:{"click":(e) => {
        e.preventDefault()
        e.stopPropagation();
        _vm.$router.push({ path: '/administracion/movimientos/clientes/controldocumentoselectronicosventa' });
      }}},[_c('i',{staticClass:"bi bi-filetype-xml"}),_c('span',[_vm._v("Documentos Electrónicos de Venta")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }